import { environment } from '../../environments/environment';

export const API_BASE_URL = environment.awsApiUrlatlas.replace(/\/+$/, '');

export const API_ENDPOINTS = {
  // Single endpoint: assetNumber param returns full details; mode+term params return search results.
  assetDetails: `${API_BASE_URL}/assetDetails`,
  // POST endpoint for creating a new equipment row; duplicate asset numbers return HTTP 409.
  addAssetDetails: `${API_BASE_URL}/addassetDetails`,
  // PUT/POST endpoint that creates or updates an equipment row; override_ind is flipped to 'Y' server-side.
  assetUpsert: `${API_BASE_URL}/assetUpsert`,
  // Returns every data_set_name (e.g. Region_Name, Owner_Name) mapped to its list of set_element_name values.
  lookups: `${API_BASE_URL}/Filter`,
  dashboard: `${API_BASE_URL}/details`,
  formPrintLog: `${API_BASE_URL}/formPrintLog`,
} as const;
